import React, { useState } from "react";
import { Button, Input, Label, FormGroup } from "reactstrap";
import Modal from "../Modals/Modal";
import { GradeCode } from "../../utils/enums";
import OutlineButton from "../Buttons/OutlineButton";

const gradeLabels = {
  [GradeCode.KG1]: "رياض أطفال 1",
  [GradeCode.KG2]: "رياض أطفال 2",
  [GradeCode.G1]: "الصف الأول",
  [GradeCode.G2]: "الصف الثاني",
  [GradeCode.G3]: "الصف الثالث",
  [GradeCode.G4]: "الصف الرابع",
  [GradeCode.G5]: "الصف الخامس",
  [GradeCode.G6]: "الصف السادس",
  [GradeCode.G7]: "الصف السابع",
  [GradeCode.G8]: "الصف الثامن",
  [GradeCode.G9]: "الصف التاسع",
  [GradeCode.G10]: "الصف العاشر",
  [GradeCode.G11]: "الصف الحادي عشر",
  [GradeCode.G12]: "الصف الثاني عشر",
};

const SyncSchoolDialog = ({ open, onClose, onConfirm, isLoading }) => {
  const [selectedGrades, setSelectedGrades] = useState([]);
  const [updateLevel, setUpdateLevel] = useState(false);

  const handleGradeToggle = (gradeCode) => {
    setSelectedGrades((prev) =>
      prev.includes(gradeCode)
        ? prev.filter((g) => g !== gradeCode)
        : [...prev, gradeCode]
    );
  };

  const handleSelectAll = () => {
    const allGrades = Object.values(GradeCode);
    if (selectedGrades.length === allGrades.length) {
      setSelectedGrades([]);
    } else {
      setSelectedGrades(allGrades);
    }
  };

  const handleConfirm = () => {
    onConfirm(selectedGrades.length > 0 ? selectedGrades : undefined, {
      student: { updateLevel },
    });
    setSelectedGrades([]);
    setUpdateLevel(false);
  };

  const handleClose = () => {
    setSelectedGrades([]);
    setUpdateLevel(false);
    onClose();
  };

  const allGrades = Object.values(GradeCode);
  const isAllSelected = selectedGrades.length === allGrades.length;

  return (
    <Modal open={open} close={handleClose} title="مزامنة المدرسة">
      <div className="sync-school-dialog">
        <p className="text-muted text-center mb-3">
          اختر الصفوف التي تريد مزامنتها، أو اتركها فارغة لمزامنة جميع الصفوف
        </p>

        <div className="mb-3">
          <div className="mb-2 pe-2 pb-2 border-bottom d-flex gap-2">
            <Input
              type="checkbox"
              id="select-all"
              checked={isAllSelected}
              onChange={handleSelectAll}
              className="cursor-pointer"
            />
            <Label check for="select-all" className="cursor-pointer fw-bold">
              تحديد الكل
            </Label>
          </div>

          <div
            className="grades-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "8px",
              maxHeight: "300px",
              overflowY: "auto",
              padding: "8px",
            }}
          >
            {allGrades.map((gradeCode) => (
              <div key={gradeCode} className="mb-1 d-flex gap-2">
                <Input
                  type="checkbox"
                  id={`grade-${gradeCode}`}
                  checked={selectedGrades.includes(gradeCode)}
                  onChange={() => handleGradeToggle(gradeCode)}
                  className="cursor-pointer"
                />
                <Label
                  check
                  for={`grade-${gradeCode}`}
                  className="cursor-pointer"
                >
                  {gradeLabels[gradeCode]}
                </Label>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-3 pt-3 border-top d-flex gap-2 align-items-center">
          <Input
            type="checkbox"
            id="update-level"
            checked={updateLevel}
            onChange={(e) => setUpdateLevel(e.target.checked)}
            className="cursor-pointer"
          />
          <Label check for="update-level" className="cursor-pointer fw-bold">
            تحديث مستوى الطلاب
          </Label>
        </div>

        {selectedGrades.length > 0 && (
          <div className="mb-3 text-center">
            <span
              className="badge bg-info px-3 py-2"
              style={{ fontSize: "14px" }}
            >
              {selectedGrades.length} صف محدد
            </span>
          </div>
        )}

        <div className="d-flex justify-content-center gap-3 mt-4">
          <OutlineButton
            type={"button"}
            onClick={handleClose}
            title={"إلغاء"}
            color="#B3B3B3"
            style={{ maxWidth: 150, color: "#000" }}
          />
          <OutlineButton
            type={"button"}
            onClick={handleConfirm}
            title={isLoading ? "جاري المزامنة..." : "مزامنة"}
            color="#4FACC6"
            style={{ maxWidth: 150 }}
            disabled={selectedGrades.length === 0}
          />
        </div>
      </div>
    </Modal>
  );
};

export default SyncSchoolDialog;
